import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { isRejectedImageDrag } from '../../lib/helpers';

export const useInventoryPhotosDropzone = (
    isDisabled: boolean,
    onUpload: (files: File[]) => void
) => {
    const { t } = useTranslation();
    const inputId = `equipment-inventory-dropzone-${React.useId()}`;
    const inputRef = React.useRef<HTMLInputElement | null>(null);
    const dragCounterRef = React.useRef(0);
    const [isDragActive, setIsDragActive] = useState(false);
    const [isDragReject, setIsDragReject] = useState(false);

    const openFileDialog = () => {
        if (isDisabled) {
            return;
        }

        inputRef.current?.click();
    };

    const handleFiles = (files: FileList | File[]) => {
        const nextFiles = Array.from(files);

        if (nextFiles.length) {
            onUpload(nextFiles);
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) {
            return;
        }

        handleFiles(event.target.files);
        event.target.value = '';
    };

    const handleDragEnter = (event: React.DragEvent<HTMLButtonElement>) => {
        if (isDisabled) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        dragCounterRef.current += 1;
        setIsDragActive(true);
        setIsDragReject(isRejectedImageDrag(event.dataTransfer.items));
    };

    const handleDragOver = (event: React.DragEvent<HTMLButtonElement>) => {
        if (isDisabled) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        const isRejected = isRejectedImageDrag(event.dataTransfer.items);
        event.dataTransfer.dropEffect = isRejected ? 'none' : 'copy';
        setIsDragActive(true);
        setIsDragReject(isRejected);
    };

    const handleDragLeave = (event: React.DragEvent<HTMLButtonElement>) => {
        if (isDisabled) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        dragCounterRef.current -= 1;

        if (dragCounterRef.current <= 0) {
            dragCounterRef.current = 0;
            setIsDragActive(false);
            setIsDragReject(false);
        }
    };

    const handleDrop = (event: React.DragEvent<HTMLButtonElement>) => {
        if (isDisabled) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        dragCounterRef.current = 0;
        setIsDragActive(false);
        setIsDragReject(false);
        handleFiles(event.dataTransfer.files);
    };
    return {
        t,
        inputId,
        inputRef,
        isDragActive,
        isDragReject,
        openFileDialog,
        handleInputChange,
        handleDragEnter,
        handleDragOver,
        handleDragLeave,
        handleDrop,
    };
};
